import {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const usePlans = (countryCode = "IN", userId = "") => {
  const { api } = useContext(GlobalContext);

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubscriptionPlans = useCallback(async () => {
    if (!api) return;

    setLoading(true);
    setError(null);

    try {
      const response = await api.post(
        "/Entitlement/fetchSubscriptionPlans",
        {
          userid: userId,
          countryCode,
        }
      );

      setPlans(response?.data?.data || []);

      return response?.data;
    } catch (err) {
      console.error(
        "Fetch Subscription Plans Error:",
        err?.response?.data || err
      );

      setError(err);
      setPlans([]);

      return null;
    } finally {
      setLoading(false);
    }
  }, [api, countryCode, userId]);

  useEffect(() => {
    fetchSubscriptionPlans();
  }, [fetchSubscriptionPlans]);

  return {
    plans,
    setPlans,
    loading,
    error,
    refetch: fetchSubscriptionPlans,
  };
};

export default usePlans;